import React, { useCallback, useEffect, useState, useRef } from "react";
import logoimage from '../images/logo2.png'
import { useDispatch, useSelector } from "react-redux";
import { setup, connect } from "../redux/blockchain/blockchainActions.js";
import { fetchData } from "../redux/data/dataActions";

import { twitter, instagram, discord, opensea } from "../icons";

import * as s from "../styles/globalStyles";
import styled from "styled-components";

export const StyledButton = styled.button`

  border: none;
  background-color: #ffffff;
  padding: 10px;
  font-weight: bold;
  color: #000000;
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;


function Header()   {

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("Maybe it's your lucky day.");
  const [claimingNft, setClaimingNft] = useState(false);

  const loadBlockchain = useCallback(async () => {
    dispatch(setup());
  }, [])

  useEffect(() => {
    loadBlockchain();
  }, []);

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const [toggleMenu, setToggleMenu] = useState(false);

  const handleToggle = () =>{
    setToggleMenu(!toggleMenu)
  }
  
    return (

      <header
          data-aos="fade-down"
          data-aos-duration="500"
          className="flex justify-between py-8 bg-white w-full xl:px-15% px-8 md:px-10%"
        >
          <div className="flex items-center">
            <img src="assets/images/babybad/babybadlogo.png" alt="logo" className="hidden w-24 xs:inline" />
            <ul className="hidden ml-4 space-y-2 text-lg list-none md:block md:ml-10 lg:space-x-4 lg:flex lg:space-y-0 lg:text-base">
              <li>
                <a href="#about" className="text-gray-700 hover:text-teal-600">
                  About
                </a>
              </li>
              <li>
                <a href="#mint" className="text-gray-700 hover:text-teal-600">
                  Mint
                </a>
              </li>
            </ul>
          </div>
          <div className="flex items-center">
            <a href="https://twitter.com/babybad_nft" aria-label="twitter" target="_blank" rel="noreferrer noopener" className="flex items-center justify-center p-3 mr-4 transition-all duration-300 ease-in-out border-black cursor-pointer hover:opacity-80 border-default md:p-4">
              <img src={twitter} alt="twitter" />
            </a>
            <a href="https://www.instagram.com/babybad_nft/" aria-label="instagram" target="_blank" rel="noreferrer noopener" className="flex items-center justify-center p-3 mr-4 transition-all duration-300 ease-in-out border-black cursor-pointer hover:opacity-80 border-default md:p-4">
              <img src={instagram} alt="instagram" />
            </a>
            <a href="https://discord.gg/Jns3etFubS" aria-label="discord" target="_blank" rel="noreferrer noopener" className="flex items-center justify-center p-3 mr-4 border-black cursor-pointer hover:opacity-80 border-default md:p-4">
              <img src={discord} alt="discord" />
            </a>
            <a href="https://opensea.io/collection/babybad-1" className="w-6 mt-1.5 lg:mt-3 h-7 lg:w-10 lg:h-10" aria-label="discord" target="_blank" rel="noreferrer noopener" className="flex items-center justify-center p-3 mr-4 border-black cursor-pointer hover:opacity-80 border-default md:p-4">
              <img src={opensea} alt="opensea"/>
            </a>
            <div>
            {blockchain.account === null ? (
                  <div>
                    <a
                      href="/"
                      className="text-sm md:text-base bg-black hover:bg-gray-800 text-white h-10 md:px-5 px-2.5 md:py-6 py-3 flex items-center cursor-pointer"
                      aria-label="connect"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        }}
                    >
                      Connect Metamask
                    </a>
                    {blockchain.errorMsg !== "" ? (
                      blockchain.errorMsg === "Install Metamask." ?
                      <>
                        <a href="https://metamask.io/download/" className="block mr-5 text-xs text-black cursor-pointer lg:inline-block hover:text-teal-400">
                          {blockchain.errorMsg}
                        </a>
                      </>
                      :
                      <>
                        <a className="block mr-5 text-xs text-black cursor-pointer lg:inline-block">
                          {blockchain.errorMsg}
                        </a>
                      </>
                    ) : null}
                  </div>
                ) : (
                  <div>
                  <a className="text-sm md:text-base bg-black text-white h-10 md:px-5 px-2.5 md:py-6 py-3 flex items-center cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      getData();
                    }}>{claimingNft ? "BUSY" : blockchain.account.substr(0, 6) + '...' + blockchain.account.substr(-4)}
                  </a>
                  </div>
                )}
            </div>
          </div>
      </header>
    );
  }


export default Header;

